module.exports = __webpack_public_path__ + "img/eg.7459922f.svg";